import { Injectable } from "@angular/core";
import { DataService } from "../../core/services/data.service";
import { NotificationService } from "../../core/services/notification.service";
import { HttpClient } from "@angular/common/http";
import { LaboratoryRequestExaminationEquipmentDto } from "../models/laboratory/laboratory-request-examination-equipment.dto";
import { Observable } from "rxjs";

@Injectable()
export class LaboratoryRequestExaminationEquipmentsService extends DataService<LaboratoryRequestExaminationEquipmentDto, LaboratoryRequestExaminationEquipmentDto> 
{
    constructor(http: HttpClient, notificationService: NotificationService) {
        super(http, notificationService);
        this.controllerName = 'laboratory-request-examination-equipments';
    }

    getAllByRequest(requestId: number): Observable<LaboratoryRequestExaminationEquipmentDto[]> {
        return this.getQuery<LaboratoryRequestExaminationEquipmentDto[]>(`${this.baseUrl()}/by-request/${requestId}`);
    }
}